var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Printer Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38,8V0H10v8H0v21c0,3.9,3.1,7,7,7h3v8h28v-8h3c3.9,0,7-3.1,7-7V8H38z M12,2h24v6H12V2z M36,42H12V28h24V42z   M46,29c0,2.8-2.2,5-5,5h-3v-8H10v8H7c-2.8,0-5-2.2-5-5V10h44V29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m41 17c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.92b98ed868c55c6586e33133ec775bb5.svg";
export { ForwardRef as ReactComponent };